module.exports = __webpack_public_path__ + "img/box-bg.1ec9abd1.png";